<template>
    <div>
        <v-text-field
            v-if="disabled || readonly"
            v-model="formatted"
            :disabled="disabled"
            class="input-group--date-text-field"
        ></v-text-field>
        <v-menu
            ref="menu"
            v-if="!disabled && !readonly"
            :close-on-content-click="false"
            v-model="menu"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-top="20"
            max-width="290px"
            style="cursor:arrow"
        >
            <v-text-field
                placeholder="DD/MM/AAAA"
                :name="label"
                slot="activator"
                v-model="formatted"
                readonly
                style="pointer-events: none;"
                :rules="rules"
            ></v-text-field>

            <v-date-picker
                v-model="picker"
                @input="
                    formatted = formatDate($event);
                    menu = false;
                "
                no-title
            >
            </v-date-picker>
        </v-menu>
    </div>
</template>

<script>
export default {
    props: {
        model: {
            type: String
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        label: {
            type: String,
            required: false
        },
        rules: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    data() {
        return {
            picker: this.model,
            formatted: this.model !== null ? this.formatDate(this.model) : "",
            menu: false
        };
    },
    watch: {
        picker: "emit",
        model: "copy"
    },
    methods: {
        copy() {
            this.picker = this.model;
            this.formatted =
                this.model !== null ? this.formatDate(this.model) : "";
        },
        emit(val) {
            if (!val.includes("T00:00")) val += "T00:00";
            this.$emit("update:model", val);
            this.$emit("change", val);
        },
        formatDate(val) {
            if (!val) return "";
            if (!val.includes("T00:00")) val += "T00:00";
            return new Date(val).toLocaleDateString("pt-BR");
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/MenuDatePicker.vue